export default {
      id: "oc-smaller-usage",
      viewBox: "0 0 1026 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-smaller",
      toString: function () {
        return this.url;
      }
    }